var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { UserPermissionModel } from '../models/user-permission-model.interface';
let UserPermissionServiceImpl = class UserPermissionServiceImpl {
    constructor(_userPermissionModel) {
        this._userPermissionModel = _userPermissionModel;
    }
    get userPermission() {
        return this._userPermissionModel.userPermission;
    }
    updateUserPermission(userPermission) {
        this._userPermissionModel.updateUserPermission(userPermission);
    }
    updateAccountPermission(accountPermission) {
        this._userPermissionModel.updateUserPermission(accountPermission);
    }
    subscribeUserPermission(callback) {
        return this._userPermissionModel.subscribeUserPermission(callback);
    }
};
UserPermissionServiceImpl = __decorate([
    injectable(),
    __param(0, inject(UserPermissionModel)),
    __metadata("design:paramtypes", [typeof (_a = typeof UserPermissionModel !== "undefined" && UserPermissionModel) === "function" ? _a : Object])
], UserPermissionServiceImpl);
export { UserPermissionServiceImpl };
